import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { servicePackageInsert } from "../store/actions"
import { selectPackagesWithOnlyIds } from "../store/reducers/servicePackageReducer"
import { Package } from "./Package"

const styles = {
	root: {
		"& .MuiTextField-root": {
			margin: "8px",
		},
	},
	text: {
		margin: "16px",
		justifyContent: "space-between",
	},
	buttons: {
		justifyContent: "flex-end",
		marginRight: "16px",
		marginBottom: "16px",
		marginTop: "16px",
	},
	button: {
		marginLeft: "16px",
	},
}

const AdminPackage = () => {
	const dispatch = useDispatch()
	const packages = useSelector((state) => selectPackagesWithOnlyIds(state))
	const packagesMemo = useMemo(() => packages, [packages])
	const spInsert = () => dispatch(servicePackageInsert(packagesMemo))

	return (
		<>
			<Grid container direction="row" justifyContent={"space-between"} sx={styles.root}>
				<Grid item sx={styles.text}>
					<Typography variant="h5">Paketit</Typography>
				</Grid>
				<Grid item sx={styles.buttons}>
					<Button variant="contained" color="primary" sx={styles.button} onClick={() => spInsert()}>
						Lisää Paketti
					</Button>
				</Grid>
			</Grid>
			<Grid>
				{packagesMemo.map((packageId) => {
					return <Package key={packageId} packageId={packageId} styles={styles} />
				})}
			</Grid>
		</>
	)
}

export default AdminPackage
